import Product from '../components/Product/Product';
import { Container, Row, Spinner } from 'react-bootstrap';
import { GetProductsByCategory } from '../hooks/GetProductsByCategory';
import { Link, useParams } from 'react-router-dom';
import { User } from '../models/user';
import { BsFillHouseFill } from "react-icons/bs";
import { Group2Schema } from '../models/Group2Items';
import { Group1Schema } from '../models/Group1Items';

interface ProductPageProps {
    loggedInUser: User | null;
    group1: Group1Schema[];
    group2: Group2Schema[];
}

const ProductsPage = ({ loggedInUser, group1, group2 }: ProductPageProps) => {
    const currGroup2 = useParams();
    const { products, loading } = GetProductsByCategory(loggedInUser, currGroup2);
    // const { products, loading } = GetProductsByCategory(currGroup2);
    // const currGroup2 = useParams();
    const g2Parent = group2.find(grp2 => (Number(grp2.ID) === Number(currGroup2.category)));
    const g1Parent = group1.find(grp1 => (Number(grp1.CODE) === Number(g2Parent?.GRP1)));

    return (
        loggedInUser &&
        (
        <>
            <ol className="breadcrumb bg-dark px-4 d-flex">
                <Link to={"/"} className="text-light px-2">
                    <BsFillHouseFill />
                </Link>
                <span className="breadcrumb-divider">{'>'}</span>
                <Link to={`/g1/${g1Parent?.CODE}`} className="text-light px-2">
                    {g1Parent?.NAME}
                </Link>
                <span className="breadcrumb-divider">{'>'}</span>
                    <span className="active text-light text-underline px-2">{ g2Parent?.NAME }</span>
            </ol>
            <Container className="pt-2">
            {
            loading
                ? (
                    <Container className="d-flex align-items-center justify-content-center">
                        <Spinner className="LoadingSpinner" animation="border" role="status" variant="secondary">
                            <span className="visually-hidden">Περιμένετε λίγο...</span>
                        </Spinner>
                    </Container>
                ) : (
            <>
            <Row xs={1} md={1} lg={1} xl={1} className="g-0 px-0 justify-content-center">
                {products.map(product => (
                <Product key={product.ID} product={product}/>
                ))}
            </Row>
            </>
            )}
            </Container>
        </>
        )
    );
}

export default ProductsPage;